import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { images } from '../data/images';

const Solutions = () => {
  const { t } = useLanguage();

  const solutionImages = [
    images.solutions.metering,
    images.solutions.energy,
    images.solutions.tracking,
    images.solutions.airQuality,
    images.solutions.library,
    images.solutions.parking,
    images.solutions.e2Care,
    images.solutions.e2Health
  ];

  return (
    <section id="solutions" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.solutions.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.solutions.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.solutions.items.map((solution, index) => (
            <Card
              key={index}
              className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-teal-500 overflow-hidden"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={solutionImages[index]}
                  alt={solution.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 to-transparent"></div>
              </div>

              <CardHeader>
                <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors">
                  {solution.title}
                </CardTitle>
                <CardDescription className="text-gray-600">
                  {solution.description}
                </CardDescription>
              </CardHeader>

              <CardContent>
                {/* Benefit Badge */}
                <div className="flex items-center space-x-2 bg-teal-50 px-4 py-2 rounded-lg mb-4">
                  <TrendingUp className="w-5 h-5 text-teal-600" />
                  <span className="text-sm font-semibold text-teal-800">{solution.benefit}</span>
                </div>

                <Button
                  variant="ghost"
                  className="w-full group-hover:bg-teal-50 group-hover:text-teal-700 transition-colors"
                >
                  {t.solutions.cta}
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;